import { T } from "../../app/tokens.js";
import { budgetHealth, milestoneSignal } from "../../lib/projectDisplaySignals.js";

export const budgetHealthColor = health => health.state === "over" ? T.red : health.state === "amber" ? T.amberDark : health.state === "not_tracked" ? T.mid : T.dark;

export function budgetHealthText(health, currency = "USD") {
  return health.label;
}

export function BudgetHealthLabel({ budget, forecast, currency = "USD" }) {
  const health = budgetHealth(budget, forecast);
  return <span data-budget-health={health.state} style={{ color: budgetHealthColor(health), fontSize: T.fsXs, fontWeight: T.fwRegular }}>{budgetHealthText(health, currency)}</span>;
}

export function MilestoneSignal({ milestone, timeZone, now }) {
  const signal = milestoneSignal(milestone, timeZone, now);
  if (signal.reason?.startsWith("Project time zone")) return <span title={signal.reason} style={{ color: T.mid, fontSize: T.fsXxs }}> · Overdue status unknown (time zone unavailable)</span>;
  if (!signal.overdue) return null;
  return <span data-milestone-overdue="true" style={{ color: T.red, fontSize: T.fsXs, whiteSpace: "nowrap", flexShrink: 0 }}>{signal.days}d overdue</span>;
}
